import { Font } from '@utmb/design-system/text/font';
import { IconsEnum } from '@utmb/types/icons';
import React from 'react';
import { Icon } from '../icons/Icon';
import styles from './running-stones.module.scss';

interface RunningStonesProps {
    quantity?: number;
    size?: number;
}

const RunningStones = ({ quantity, size = 54 }: RunningStonesProps) => {
    return (
        <div className={styles.runningStoneContent}>
            <div className={styles.runningStoneBg}>
                <Icon variant={quantity && quantity < 2 ? IconsEnum.RUNNING_STONE : IconsEnum.RUNNING_STONES} width={size} height={size} />
            </div>
            {quantity ? (
                <Font.OxaniumRegular desktop={size < 41 ? '16' : '25'} as="div" className={styles.stonesQuantity}>
                    {quantity}
                </Font.OxaniumRegular>
            ) : (
                <Font.FuturaMedium desktop={size < 41 ? '16' : '25'} as="div" className={styles.stonesQuantity}>
                    M
                </Font.FuturaMedium>
            )}
        </div>
    );
};

export default RunningStones;
